import { MenuItem, useToast } from '@chakra-ui/react'
import { FC, useState } from 'react'
import { GrDocumentCsv } from 'react-icons/gr'

import { exportarModeloTabelas } from '@service/ParametroCompra'

const ActionModeloTabelasPurchaseUserExport: FC = () => {
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()

  const handleExport = async () => {
    setIsLoading(true)
    try {
      const response = await exportarModeloTabelas()

      // Criar link de download
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.download = 'Modelo-Tabelas.csv'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)

      toast({
        title: 'Sucesso!',
        description: 'Modelo Tabelas exportado com sucesso',
        status: 'success',
        duration: 2000,
        isClosable: true
      })
    } catch (error: any) {
      toast({
        title: 'Erro ao exportar',
        description:
          error.response?.data?.message || 'Erro ao exportar Modelo Tabelas',
        status: 'error',
        duration: 3000,
        isClosable: true
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <MenuItem
      p="2px 12px"
      fontSize="sm"
      _hover={{ bg: 'gray.400' }}
      isDisabled={isLoading}
      onClick={handleExport}
      icon={<GrDocumentCsv />}
    >
      {isLoading ? 'Exportando...' : 'Exportar Modelo Tabelas'}
    </MenuItem>
  )
}

export default ActionModeloTabelasPurchaseUserExport
